// Revise ▸ Readers (the web's): beta-reader rounds with web links, and the notes that come back. The Mac keeps them in
// its Beta Readers sheet.
export { ReadersPage as component } from '../../views/ReadersPage.tsx';
export const room = 'revise';
export const page = 'readers';
export const title = 'Readers';
export const help = 'beta-readers';
export const order = 1;
